import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Button } from '@blueprintjs/core';
import { useAppSelector } from '../../../store/store';
import { getDesignElements } from '../../../store/selector/brand-elements.selector';
import {
    getActiveTab,
    getFetchBrandElementsLoading,
} from '../../../store/selector/common.selector';
import { TabKey } from '../../../constants/common';
import { nextPermutation, normalizeColor } from '../../../utils/color.utils';
import { getTemplateWithShuffledColor } from '../../../utils/template.util';

export const PolotnoShuffleButton = observer(({ store }: { store: any }) => {
    const designElementsData = useAppSelector(getDesignElements);
    const activeTab = useAppSelector(getActiveTab);
    const brandElementsLoading = useAppSelector(getFetchBrandElementsLoading);

    const [colors, setColors] = useState<string[]>([]);

    useEffect(() => {
        if (activeTab === TabKey.EDIT && designElementsData && designElementsData.colors) {
            setColors(designElementsData.colors);
        }
    }, [activeTab, designElementsData]);

    const handleColorShuffle = () => {
        if (colors.length < 2) return;
        const currentColors = [...colors];
        const newColors = nextPermutation(currentColors);
        const colorMapping: Record<string, string> = {};
        currentColors.forEach((color, index) => {
            const key = normalizeColor(color);
            colorMapping[key] = newColors[index];
        });

        const template = store.toJSON();
        const newTemplate = getTemplateWithShuffledColor(template, colorMapping);
        store.loadJSON(newTemplate);
        setColors(newColors);
    };

    return (
        <>
            {!brandElementsLoading && colors.length > 1 && (
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip>Shuffle Colors</Tooltip>}
                >
                    <Button
                        icon="swap-horizontal"
                        intent="primary"
                        // loading={updateProjectLoading || updateCampaignAdLoading}
                        onClick={handleColorShuffle}
                        className="d-flex align-item-center justify-content-center me-2"
                    ></Button>
                </OverlayTrigger>
            )}
        </>
    );
});
